import {AfterViewInit, Directive, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {TableEntry} from '@app/admin/customer-controlled-modules/modules/util/table-entry';
import {fromEvent, Subject} from 'rxjs';
import {filter, takeUntil, tap} from 'rxjs/operators';

@Directive()
export abstract class GenericSearchTableActionsDirective<T extends TableEntry<T1>, T1> implements OnDestroy, AfterViewInit {
  dataSource = new MatTableDataSource<T>();
  @ViewChild('filter') filter: ElementRef;
  @ViewChild('sortForDataSource') sortForDataSource: MatSort;
  @ViewChild('paginatorForDataSource') paginatorForDataSource: MatPaginator;

  showLoading = false;

  private loading = 0;
  private destroyed = new Subject<void>();

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

  ngAfterViewInit() {
    if (this.filter) {
      fromEvent<KeyboardEvent>(this.filter.nativeElement, 'keyup')
        .pipe(
          filter(e => e.key === 'Enter'),
          tap(_ => {
            this.dataSource.data = [];
            this.search(this.filter.nativeElement.value.trim());
          }),
          takeUntil(this.destroyed)
        )
        .subscribe();
    }
    this.dataSource.paginator = this.paginatorForDataSource;
    this.dataSource.sort = this.sortForDataSource;
  }

  cancelRow(entry: T) {
    const data = this.dataSource.data;
    const index = data.indexOf(entry);
    data[index] = this.newTableEntry(entry.entry, false);
    this.dataSource.data = data;
  }

  protected startLoading() {
    this.loading++;
    if (this.loading > 0) {
      this.showLoading = true;
    }
  }

  protected stopLoading(): boolean {
    this.loading--;
    if (this.loading === 0) {
      this.showLoading = false;
      return true;
    }
    return false;
  }

  abstract saveRow(entry: T): void;

  abstract newTableEntry(entry: T1, editing: boolean): T;

  abstract search(key: string): void;
}
